// extracted by mini-css-extract-plugin
module.exports = {"accordion_wrapper":"faq_accordion_wrapper__2kF7E","accordionbtn":"faq_accordionbtn__15Qnl","accordion_body":"faq_accordion_body__2xnC_","bgcolor":"faq_bgcolor__24jut"};